module.exports = __webpack_public_path__ + "img/my.a3d5577d.svg";